import {
  GET_LIST,
  GET_MANY,
  GET_ONE,
  UPDATE,
  CREATE,
  DELETE,
} from 'react-admin';
import queryString from 'query-string';
import { getApiUrlForResource } from '../services/apiUrlResolver';

export const PRODUCT_FEATURES_RESOURCE_NAME = 'product-features';

// Helper function to get API URL at request time
const getApiUrl = () => getApiUrlForResource(PRODUCT_FEATURES_RESOURCE_NAME);

export const providerRequestToHttpRequest = (requestType, requestParams) => {
  switch (requestType) {
    case GET_LIST: {
      const { page, perPage } = requestParams.pagination;
      const { field, order } = requestParams.sort;
      const queryParams = {
        sort: JSON.stringify([field, order]),
        range: JSON.stringify([(page - 1) * perPage, page * perPage]),
      };
      return {
        url: `${getApiUrl()}/${PRODUCT_FEATURES_RESOURCE_NAME}?${queryString.stringify(queryParams)}`,
      };
    }
    case GET_ONE: {
      return {
        url: `${getApiUrl()}/${PRODUCT_FEATURES_RESOURCE_NAME}/${requestParams.id}`,
      };
    }
    case GET_MANY: {
      const query = {
        ids: JSON.stringify(requestParams.ids),
      };
      return {
        url: `${getApiUrl()}/${PRODUCT_FEATURES_RESOURCE_NAME}?${queryString.stringify(query)}`,
      };
    }
    case UPDATE:
      return {
        url: `${getApiUrl()}/${PRODUCT_FEATURES_RESOURCE_NAME}/${requestParams.id}`,
        options: {
          method: 'PUT',
          body: JSON.stringify(requestParams.data),
          headers: {
            'Content-Type': 'application/json',
          },
        },
      };
    case CREATE:
      return {
        url: `${getApiUrl()}/${PRODUCT_FEATURES_RESOURCE_NAME}`,
        options: {
          method: 'POST',
          body: JSON.stringify(requestParams.data),
          headers: {
            'Content-Type': 'application/json',
          },
        },
      };
    case DELETE:
      return {
        url: `${getApiUrl()}/${PRODUCT_FEATURES_RESOURCE_NAME}/${requestParams.id}`,
        options: { method: 'DELETE' },
      };
    default:
      throw new Error(`Unsupported fetch action type ${requestType}`);
  }
};

const httpResponseToProviderData = (
  httpResponse,
  requestType,
  requestParams,
) => {
  let { headers, json } = httpResponse;
  switch (requestType) {
    case GET_LIST:
      return {
        data: json,
        total: json.length, // API returns full list
      };
    case GET_MANY:
      return {
        data: json,
      };
    case UPDATE:
    case CREATE:
    case GET_ONE:
      return {
        data: json,
      };
    case DELETE:
      return {
        data: { id: requestParams.id },
      };
    default:
      return { data: json };
  }
};

export default {
  resource: PRODUCT_FEATURES_RESOURCE_NAME,
  providerInterface: {
    providerRequestToHttpRequest,
    httpResponseToProviderData,
  },
};

